<template>
  <div id="login-page" class="relative mx-auto h-full w-full max-w-screen-md p-8 md:p-0">
    <div class="pt-32 mx-auto max-w-sm">
      <v-form
        ref="form"
        class="elevation-6 p-4 rounded-md white"
        lazy-validation
      >
        <v-text-field
          v-model="email"
          autocomplete="false"
          class="mb-2"
          label="E-mail"
          required
          variant="outlined"
          :rules="emailRules"
        ></v-text-field>

        <v-text-field
          v-model="password"
          autocomplete="false"
          class="mb-4"
          label="Password"
          required
          variant="outlined"
          :rules="[required, min8]"
          type="password"
        ></v-text-field>

        <v-text-field
          v-model="confirmPassword"
          autocomplete="false"
          class="mb-4"
          label="Confirm password"
          required
          variant="outlined"
          :rules="[required, min8, matchingPasswords]"
          type="password"
        ></v-text-field>

        <v-btn
          :disabled="!email"
          color="primary"
          @click="resetPassword"
        >
          Reset password
        </v-btn>

      </v-form>
    </div>
    <v-snackbar v-model="successState" timeout="3000">
        {{ successStateText }}
        <template v-slot:action="{ attrs }">
            <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="successState = false"
            >
                Close
            </v-btn>
        </template>
    </v-snackbar>
    <v-snackbar v-model="errorState" color="error" timeout="3000">
        {{ errorStateText }}
        <template v-slot:action="{ attrs }">
            <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="errorState = false"
            >
                Close
            </v-btn>
        </template>
    </v-snackbar>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ResetPassword',
  data() {
    return {
      valid: false,
      token: '',
      email: '',
      emailRules: [
        (v: string) => !!v || 'E-mail is required',
        (v: string) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      password: '',
      confirmPassword: '',
      validating: false,

      successState: false,
      successStateText: '',
      errorState: false,
      errorStateText: 'Something went wrong. Please try again.',
    };
  },
  created() {
    // Set token from route query
    this.token = this.$route.query.token as string || '';
    // Attach event listeners
    this.$eventBus.on('emit-success', this.setSuccessState);
    this.$eventBus.on('emit-error', this.setErrorState);
  },
  methods: {
    required(value) {
      if (value) {
        return true;
      } else {
        return 'This field is required.';
      }
    },
    min8(value) {
      if (value.length >= 8) {
        return true;
      } else {
        return 'Password should have more than 6 characters.';
      }
    },
    matchingPasswords() {
      if (this.password === this.confirmPassword) {
        return true;
      } else {
        return 'Passwords does not match.';
      }
    },
    async resetPassword() {
      const payload = {
        token: this.token,
        email: this.email,
        password: this.password,
        password_confirmation: this.confirmPassword,
      };

      const data = await this.$store.dispatch('resetPassword', payload);

      if (!!data && data.status) {
        this.$eventBus.emit('emit-success', { state: true, text: data.message });
        this.forwardAfterResetPassword();
      } else {
        this.$eventBus.emit('emit-error', { state: true, text: data.message });
      }
    },
    setErrorState({ state, text }) {
      this.errorState = state;
      if (text || text === '') { this.errorStateText = text; }
      else { this.errorStateText = 'Something went wrong. Please try again.'; }
    },
    setSuccessState({ state, text }) {
      this.successState = state;
      this.successStateText = text;
    },
    forwardAfterResetPassword() {
      setTimeout(async () => {
        await this.$router.push({name: 'login'});
      }, 2000);
    },
  },
});
</script>

<style scoped>

</style>
